var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { clsx } from "../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { twMerge } from "../node_modules/.pnpm/tailwind-merge@3.3.0/node_modules/tailwind-merge/dist/bundle-mjs.js";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
__name(cn, "cn");
function valueUpdater(updaterOrValue, ref) {
  ref.value = typeof updaterOrValue == "function" ? updaterOrValue(ref.value) : updaterOrValue;
}
__name(valueUpdater, "valueUpdater");
export {
  cn,
  valueUpdater
};
